import React, {useEffect, useState} from 'react';
import Authenticated from "@/Layouts/Authenticated";
import WelcomeAdmin from "@/Pages/Dashboard/WelcomeAdmin";
import CookiePopup from "@/Components/CookiePopup";
import {getCookie, setCookie} from "@/Utilities/CookieManager";
import AmplifySpinner from "@/Components/AmplifySpinner";

const Dashboard = () => {
    const [showCookiePopup, setShowCookiePopup] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    const [userData, setUserData] = useState(null);
    const [features, setFeatures] = useState(null);
    const [salesloftURL, setSalesloftURL] = useState(null);

    // ensures proper styling after rendering from buyflow
    useEffect(() => {
        if(document.body.id) {
            document.body.removeAttribute('id');
        }
    }, []);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        try {
            const response = await axios.get(route('bff.webapp.dashboard'));
            const dashboardData = response.data;
            setUserData(dashboardData.user);
            setFeatures(dashboardData.features);
            setSalesloftURL(dashboardData.salesloft_url);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="body-content">
            <div className="dashboard-background">
                <img className="fill" src="/images/dashboard-ellipse.svg" />
            </div>

            {isLoading ? (
                <AmplifySpinner />
            ) : (
                <>
                    <WelcomeAdmin
                        userData={userData}
                        features={features}
                        salesloftURL={salesloftURL}
                    />
                    {(showCookiePopup && !getCookie("cookieConsent")) && (
                        <CookiePopup
                            setShowCookiePopup={setShowCookiePopup}
                            setCookie={setCookie}
                        />
                    )}
                </>
            )}
        </div>
    );
}

Dashboard.layout = page => <Authenticated children={page}></Authenticated>

export default Dashboard

